import React from "react";
import { Box, ButtonBase, Stack, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import PersonRounded from "@mui/icons-material/PersonRounded";
import { FONTS } from "../constants/styles";

interface EmptyListStateProps {
    primaryText: string;
    secondaryText?: string;
    icon?: React.ReactElement;
    button?: {
        text: string;
        icon?: React.ReactElement;
        onClick: () => void;
    };
}

const EmptyListState = (props: EmptyListStateProps) => {
    const { primaryText, secondaryText, icon, button } = props;
    const theme = useTheme();
    const primary = theme.palette.primary.main;

    return (
        <Stack
            flex={1}
            alignItems="center"
            justifyContent="center"
            spacing={2.5}
            sx={{ px: 3, mb: "50%" }}
        >
            <Box
                sx={{
                    width: 64,
                    height: 64,
                    borderRadius: "50%",
                    bgcolor: alpha(primary, 0.08),
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {icon ?? (
                    <PersonRounded
                        sx={{ fontSize: 28, color: primary, opacity: 0.5 }}
                    />
                )}
            </Box>
            <Typography
                fontFamily={FONTS.display}
                fontSize="18px"
                fontWeight={600}
            >
                {primaryText}
            </Typography>
            {secondaryText && (
                <Typography
                    fontSize="13px"
                    color="text.secondary"
                    textAlign="center"
                >
                    {secondaryText}
                </Typography>
            )}
            {button && (
                <ButtonBase
                    onClick={button.onClick}
                    sx={{
                        mt: "320px !important",
                        height: 40,
                        borderRadius: "20px",
                        px: 2.5,
                        bgcolor: alpha(primary, 0.08),
                        display: "flex",
                        alignItems: "center",
                        gap: 0.75,
                    }}
                >
                    {button.icon}
                    <Typography
                        fontSize="14px"
                        fontWeight={600}
                        color={primary}
                    >
                        {button.text}
                    </Typography>
                </ButtonBase>
            )}
        </Stack>
    );
};

export default EmptyListState;
